<div class="modal-header">
    <h4 class="modal-title">{{Header}}</h4>
    <!-- <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button> -->
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-12">
            <label for="Remark" class="form-font-label">Remark</label>
            <input type="text" class="form-control" placeholder="Ex. Remark"
                id="Remark" name="Remark" [(ngModel)]="Detail.Remark"
                #Remark="ngModel" required>
            <div class="invalid-feedback">
                Please enter remark!
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" [disabled]="isDisabled" (click)="close()"><i
            class="bi bi-x" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Cancel':'Loading...'}}</button>

    <button type="button" class="btn btn-danger" [disabled]="isDisabled" (click)="Save('Reject')" *ngIf="showReject"><i class="bi bi-x"
            *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Reject':'Loading...'}}</button>


    <button type="button" class="btn btn-info" [disabled]="isDisabled" (click)="Save('ReInstate')"
        *ngIf="showReInitiat"><i class="bi bi-arrow-clockwise" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'ReInstate':'Loading...'}}</button>

    <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="Save('Approve')" *ngIf="showApprove"><i class="bi bi-check"
            *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?this.PostiveButton:'Loading...'}}</button>
</div>